(function () {
  class ScreenshotAnimator extends PIXI.Container {
    constructor() {
      super();
      this._interval = undefined;
      this._screenshots = [];
      this._currentIndex = 0;
      this._active = false;
    }

    initialise(json, fqn) {
      this._interval = json.interval === undefined ? 1000 : json.interval;

      for (let i = 0; i < json.screenshots.length; ++i) {
        let ssData = json.screenshots[i];
        let container = resourceManager.createObject(
          "container",
          "screenshot" + (i + 1),
          this.name
        );
        let sprite = resourceManager.createObject(
          "sprite",
          "screenshotImage",
          container.name,
          { fileName: ssData.imageFilename, anchor: json.anchor }
        );

        let substitutes = ssData.substitutes;
        if (!substitutes) {
          substitutes = [];
        }
        let translatedText = gdk.translateText(
          ssData.translationPhrase,
          substitutes
        );
        let text = resourceManager.createObject(
          "text",
          "screenshotText",
          container.name,
          {
            text: translatedText,
            fontDefinition: json.fontDefinition,
            y: json.textOffset,
            maxWidth: json.maxWidth,
            anchor: json.anchor,
            fontOverrides: json.fontOverrides,
          }
        );
        this._screenshots.push(container);
      }

      this.showScreenshot(this._currentIndex);
    }

    showScreenshot(index) {
      for (let i = 0; i < this._screenshots.length; ++i) {
        this._screenshots[i].visible = i === index;
      }
    }

    nextScreenshot() {
      if (!this._active) return;

      this._currentIndex = (this._currentIndex + 1) % this._screenshots.length;
      this.showScreenshot(this._currentIndex);

      const self = this;
      timerManager.addTimer(this._interval, undefined, function () {
        self.nextScreenshot();
      });
    }

    start() {
      this._active = true;
      this._currentIndex = -1;
      this.nextScreenshot();
      this.showScreenshot(this._currentIndex);
    }

    stop() {
      this._active = false;
    }
  }

  let create = function (json) {
    return new ScreenshotAnimator();
  };

  let init = function (json, obj) {
    obj.initialise(json, json.FQN);
  };

  let getFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "ScreenshotAnimator",
    create,
    init,
    getFilesRequired
  );
})();
